import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { ConfigSettingsService } from '../providers';
import { inject } from '@angular/core';

export const isEinreichungV3ActivatedGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const configService: ConfigSettingsService = inject(ConfigSettingsService);

  const reverseEinreichungV3Check: boolean = route.data['reverseEinreichungV3Check'];
  const { einreichungV3Activated } = configService.appSettings;

  return reverseEinreichungV3Check ? !einreichungV3Activated : !!einreichungV3Activated;
};
